module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-home"
  }, [_c('div', {
    class: _vm.showLogo ? '' : 'hide',
    attrs: {
      "id": "gradient-logo"
    }
  }, [_c('gradient-canvas', {
    attrs: {
      "name": "canvas-interactive-logo",
      "default-state": "home-state"
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask"
  }, [_c('img', {
    attrs: {
      "src": require("assets/mask/mask-logo-full.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cde0931c!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 186
// module chunks = 2